import React from 'react';
import '../../App.css';
import DeliveryCostReport from '../DeliveryCostReport';

function DeliveryCostReportPage({ sessionObject }) {
  if(!sessionObject.sessionVariables["modules"].includes("delivery-cost-analysis")){
    return;}
  return (
    <div className="page-mr">
      <DeliveryCostReport sessionObject={sessionObject}/>
    </div>
  );
}

export default DeliveryCostReportPage;